/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Card from "../Card";
import { monthDays } from "../functions/Month";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
    datalabels: { display: false },
    tooltip: {
      backgroundColor: "#fff",
      titleColor: "#000",
      bodyColor: "#4C9AFF",
      borderColor: "#4C9AFF",
      borderWidth: 1,
      padding: 10,
      cornerRadius: 8,
      callbacks: {
        label: function (context) {
          const value = context.raw;
          return value != null ? ` ${value} m³` : null;
        },
        title: function (context) {
          return context[0].label || "";
        },
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#555",
        callback: function (val) {
          const label = this.getLabelForValue(val);
          return label ? label : null;
        },
        autoSkip: false,
        maxRotation: 45,
        minRotation: 0,
      },
      grid: { display: false },
    },
    y: {
      ticks: {
        color: "#777",
        beginAtZero: true,
      },
      grid: {
        color: "#eee",
      },
    },
  },
};

const Chart1 = ({ datas, month }) => {
  const labels = [];
  const values = [];

  for (let i = 1; i <= monthDays(month); i++) {
    const key = "k" + i;
    const value = datas[key];

    if (value != null) {
      labels.push(i.toString());
      values.push(value);
    }
  }

  const data = {
    labels,
    datasets: [
      {
        label: "Ko‘rsatgich",
        data: values,
        borderColor: "#4C9AFF",
        backgroundColor: "rgba(76, 154, 255, 0.2)",
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  return (
    <Card>
      <div className='chart-box-all bg-chart8 p-4 h-[300px]'>
        <h4 className='title chart-title mb-3'>Oylik ko‘rsatgich</h4>
        <Line options={options} data={data} />
      </div>
    </Card>
  );
};

export default Chart1;
